import React, {Fragment} from "react";
import {connect} from "react-redux";
import {get as _get} from "lodash";
import {Link} from "react-router-dom";
import SETTINGS from "../../../settings.js";

import Input from "../../theme/forms/Input";
import PublicTopNav from "../../theme/nav/PublicTopNav";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import StaticCornerMap from "../../theme/maps/staticCornerMap";
import api from "../../../store/api";
import * as actions from "../../../store/actions";
import {updateOrCreateProjectLead,loginUser} from "../../../store/calls";
import validators from "../../../utils/forms/validators";
import BaseForm from "../../theme/forms/BaseForm";

import {addErrorAlert, toggleGlobalLoader, clearAllAlerts} from "../../../store/calls/alertLoadingDispatch";

import PublicWrapper from "../../theme/wrappers/PublicWrapper";
import LogoFooter from "../../theme/logoFooter/logo.js";
import TelephoneNumber from "../../subcomponents/TelephoneNumber.js";

class LeadInputStartScreen extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            menu_is_active: false,
            form_is_submitable: false,
        };
    }

    handleInputErrors = (input) => {
        this.setState({errors: {...this.state.errors, [input.dataKey]: true}});
    };

    handleInputSuccess = (input) => {
        this.setState({errors: {...this.state.errors, [input.dataKey]: false}});
    };



    handleStartProjectSubmission = (data) => {

        // start by creating an account

        this.handleUserCreateRequest(data)
            .then(() =>
                // we created the user, now log them in
                loginUser({
                    username: data.email,
                    password: data.password
                })
            )
            .then(() => {
                this.props.updateInfoFeedDisplay({
                    property_address: {
                        _property_address: _get(
                            this.props,
                            "focusedProject.computed.address.formatted_address",
                            ""
                        ),
                    },
                });

                this.props.history.push("/project");
            })
            .catch(() => {
                addErrorAlert("We created an account for you, but something went wrong. Please go attempt to login through the login page.")
            })


        //
        // updateOrCreateProjectLead({pace_available: _get(this.props, 'focusedProject.computed.programs', []).length})
        //     .then(() => this.setState({confirm_contact_info_submission: true}))
    };

    startProject = () => {
        // this.props.setFormFlowCurrStep(1);
        this.props.history.push("project");
    }

    renderHasFinancingOptions() {
        return (
            <div className="mb-6">
                <div>
                    <div className="buttons justify-start my-6">
                        <div
                            className="button refull-width-mobile is-primary is-medium is-outlined"
                            onClick={() => {
                                this.props.setFormFlowCurrStep(1);
                                this.props.clearFormFlow()
                                this.props.history.push("project")
                            }}
                        >
                            Start your financing quote
                        </div>
                        <div
                            className="button full-width-mobile is-text"
                            onClick={() => this.props.history.push("/home")}
                        >
                            Look up another
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // renderSuccessForm() {
    //   let inputs = this.successInputs.map((d) => {
    //     return {
    //       ...d,
    //       onChange: (val) => this.props.updateInputs({ [d.dataKey]: val }),
    //       onError: () => this.handleInputErrors(d),
    //       onSuccess: () => this.handleInputSuccess(d),
    //       value: this.props.focusedProject.inputs[d.dataKey],
    //     };
    //   });
    //   return (
    //       <div className="box container-form-ready-financing">
    //       <div
    //         className={"mb-3 is-size-6 has-text-primary has-text-weight-semibold"}
    //       >
    //         Ready for pace financing? Create an account or
    //         <Link
    //           to={"login"}
    //           className={"has-text-weight-bold"}
    //           style={{ color: "#6E910F" }}
    //         >
    //           {" "}
    //           login.
    //         </Link>
    //       </div>
    //       <div
    //         className={""}
    //         style={{ borderRadius: 4, padding: "none!important" }}
    //       >
    //
    //         <BaseForm
    //           onSubmit={this.handleStartProjectSubmission}
    //           inputs={this.successInputs}
    //           hideDefaultButtons
    //           onFormErrorChange={form_has_error => {
    //             this.setState({form_is_submitable: !form_has_error})}
    //           }
    //           otherButtons={
    //             <div className={"buttons justify-start my-6"}>
    //               <button
    //                   className={`button full-width-mobile is-primary is-medium is-outlined
    //                                         ${this.state.form_is_submitable ? '' : 'disabled'}`}
    //                   type={'submit'}
    //               >
    //                 Get Financing
    //               </button>
    //               <div
    //                   className={"button full-width-mobile  is-text"}
    //                   onClick={() => this.props.history.push("/home")}
    //               >
    //                 Look up another
    //               </div>
    //             </div>
    //           }
    //         />
    //
    //       </div>
    //     </div>
    //   );
    // }

    // gets the lat lon and offsets it by a small amount so that I can put it in the corner. Otherwise the static
    // map returns with the marker directly in the center, and I can't cut it in half.
    getStaticMap = () => {
        let {lat, lng} = _get(this.props, "focusedProject.computed.address", {
            lat: 37.819929,
            lng: -122.478255,
        }); // defaults to golden gate bridge, because why not

        let pinLat; let pinLng; let centerLat; let centerLng;
        pinLat = lat;
        pinLng = lng;

        if (window.innerWidth <= 768) {
            centerLat = lat;
            centerLng = lng;
        } else {
            centerLat = lat + 0.0008;
            centerLng = lng - 0.001;
        }

        let img_width = window.innerWidth > 1000 ? 1000 : window.innerWidth;
        let img_height = img_width * 1.1;

        let staticMapRetrieveUrl = `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/pin-l+A0DF00(${pinLng},${pinLat})/${centerLng},${centerLat},17/${Math.floor(
            img_width
        )}x${Math.floor(img_height)}?access_token=${SETTINGS.mapboxToken}`;

        return (
            <div
                className="corner-map-wrapper"
                style={{width: img_width, height: img_height}}
            >
                <img
                    className="round-corners-md"
                    src={staticMapRetrieveUrl}
                    alt="Targeted Property"
                />
            </div>
        );
    };


    getMainMessage() {
        let programs = _get(this.props, "focusedProject.computed.programs", []);
        let pace_funders_available = _get(this.props, "focusedProject.computed.pace_funders_available", true);
        let has_pace = !!programs.length;

        if (pace_funders_available && has_pace) return (
            <p
                // style={{color: "#6E910F"}}
                className="title is-size-3 mb-1 default-primary-title decoration-double has-text-success">
                We can finance upgrades on this property! It is eligible for C-PACE and other financing mechanisms.
            </p>
        )

        if (!pace_funders_available && has_pace) return (
            <>
                <p
                    // style={{color: "#6E910F"}}
                    className="title is-size-3 mb-1 default-primary-title decoration-double has-text-success">
                    We can finance upgrades on this property!
                </p>
                {/* <p */}
                {/*    className="subtitle mt-3  default-primary-title decoration-double"> */}
                {/*    It is eligible for C-PACE, though we are still working with this program’s administrator to return automated proposals. */}
                {/*    To get competitive C-PACE proposals for this address, */}
                {/*    please call us at <Telephone className={'has-text-link'} /> or email <a href='mailto:financing@cleanfi.com'>financing@cleanfi.com</a>. */}
                {/* </p> */}
            </>

        )

         return (
                <p
                    // style={{color: "#6E910F"}}
                    className="title is-size-3 mb-1 default-primary-title decoration-double has-text-success">
                    We can finance upgrades on this property!
                </p>
            )
        
    }


    render() {
        let programs = _get(this.props, "focusedProject.computed.programs", []);
        let pace_funders_available = _get(this.props, "focusedProject.computed.pace_funders_available", true);
        let has_pace = !!programs.length;
        let {lat, lng} = _get(this.props, "focusedProject.computed.address", {
            lat: 37.819929,
            lng: -122.478255,
        }); // defaults to golden gate bridge, because why not
        console.log(his.props)
        return (

            <div className="has-background-white-ter">
                <PublicWrapper
                    showNav={false}
                    cornerCoverStyle={{display: 'none'}}
                >
                    <PublicTopNav />
                    <StaticCornerMap lat={lat} lng={lng}/>


                    <section className="page-w-corner-map">
                        {/* SET MAX WIDTH TO 1200 TO MATCH MAX SIZE OF MAPBOX STATIC IMAGE */}
                        {/* HAS PACE SECTION  */}
                        <div
                            className="page-w-corner-map__content"
                            style={{zIndex: 4, position: "relative"}}
                        >
                                {/* YES PACE SECTION  */}
                                <i
                                    className="fas fa-check-circle has-text-success is-size-1 mr-5 mb-5 is-hidden-mobile"
                                    aria-hidden="true"
                                />
                                <div style={{maxWidth: '600px'}}>
                                    {this.getMainMessage()}
                                    <p className="subtitle mt-3 mb-3">
                                        {_get(
                                            this.props,
                                            "focusedProject.computed.address.formatted_address",
                                            ""
                                        )}
                                    </p>
                                    {/* <h2 className={'is-size-4  is-size-5-mobile mt-6'}><a href='mailto:cleanfinancing@gmail.com'>Email us</a> or call us at <Telephone className={'has-text-info has-text-weight-semibold'} /> for indicative financing for this location</h2> */}
                                    {this.renderHasFinancingOptions()}
                                    <LogoFooter align="left"/>
                                </div>
                        </div>
                    </section>

                    <ConfirmModal
                        type="success"
                        visible={this.state.confirm_contact_info_submission}
                        prompt="Thanks for contacting us! Someone will reach out shortly."
                        onAccept={() => {
                            this.setState({confirm_contact_info_submission: false});
                        }}
                    />
                </PublicWrapper>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    focusedProject: state.formFlow,
    subdomainInfo: state.session.subdomainInfo,
});

const mapDispatchToProps = (dispatch) => ({
    updateInputs: (data) => dispatch(actions.formFlow.updateFormFlowInputs(data)),
    setFormFlowCurrStep: data => dispatch(actions.formFlow.setFormFlowCurrStep(data)),
    updateInfoFeedDisplay: (data) =>
        dispatch(actions.infoFeed.updateInfoFeedDisplay(data)),
    clearCurrentProject: () =>
        dispatch(actions.projectLeads.setFocusedProject(null)),
    clearFormFlow: () => actions.formFlow.clearFormFlow()
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LeadInputStartScreen);
